import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: '"Roboto", sans-serif',
    allVariants: {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
      outLine: 'none',
      border: 'none',
      textDecoration: 'none',
      textTransform: 'none',
      transition: 'all 0.2s linear',
      lineHeight: 1.5,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700&display=swap");

        html {
          font-size: 62.5%;
          overflow-x: hidden;
          scroll-behavior: smooth;
        }

        body {
          background: #25274D;
          padding-left: 30rem;
        }

        *, *::before, *::after {
          box-sizing: border-box;
        }

        section {
          padding: 1rem 5%;
          min-height: 100vh;
        }
        
        content {
          padding: 1rem 5%;
          min-height: 30vh;
        }
      `,
    },
  },
  // You can also add other theme customizations here
});

export default theme;